import { UILabel, UITableView, UITableViewDatasource, UIView, UITableViewDelegate, UITableViewCell } from "uikit";
import { UIViewController } from "uikit";
import { IndexPath } from "foundation";
import { DLDB } from "dldb";
import { BookingProductCategoryCell } from "./BookingProductCategoryCell";
import { BookingProductCategoryHeader } from "./BookingProductCategoryHeader";

export interface BookingProductCategoryViewControllerDelegate
{    
    categoryDidChange ( vc: BookingProductCategoryViewController, categoryID:string ) : void ;
    // Called when the online preset has no categories at all: the product list must show every preset product
    noCategoriesAvailable? ( vc: BookingProductCategoryViewController ) : void ;
}


export class BookingProductCategoryViewController extends UIViewController implements UITableViewDatasource, UITableViewDelegate
{
    delegate : BookingProductCategoryViewControllerDelegate = null ;

    private spinLoaderView : UIView;

    private tableViewHeader: BookingProductCategoryHeader;
    private tableView : UITableView;    

    viewDidLoad ( )
    {
        super.viewDidLoad();

        this.tableViewHeader.hidden = true;

        this.tableView.dataSource = this;
        this.tableView.delegate   = this;

        // The preset can change at runtime (an event selection): reload the categories
        DLDB.shared.cart().addObserver( this, "presetID", null );

        this.fetchCategories();
    }

    observeValueForKeyPath ( keyPath: string, type: string, object: any ) {
        if ( keyPath === "presetID" && type === "did" ) this.fetchCategories();
    }

    // PRODUCT TABLE VIEW
    numberOfSections ( tableView: UITableView ) { 
        return this.selected_categories.length + 1;
    }
    
    numberOfRowsInSection(tableView: UITableView, section: number): number {        
        return this.filter_categories[section].length;
    }    
    
    viewForHeaderInSection ( tableView:UITableView, section:number ) : UIView {
        let header = this.tableViewHeader.copy() as BookingProductCategoryHeader;
        const cat = this.filter_categories[section][ 0 ];
        header.title = cat["ParentName"];
        return header;
    }

    cellForRowAt(tableView: UITableView, indexPath: IndexPath): UITableViewCell
    {
        let cell = tableView.dequeueReusableCellWithIdentifier( "BookingProductCategoryCell" ) as BookingProductCategoryCell;
        const cat = this.filter_categories[indexPath.section][ indexPath.row ];
        cell.category = cat;
        cell.isSelected = ( indexPath.isEqualToIndexPath( this.selected_index_paths[indexPath.section] ) );
        return cell;
    }

    private selected_index_paths: IndexPath[] = []; 
    didSelectCellAtIndexPath ( tableView: UITableView, indexPath: IndexPath )
    {
        if ( indexPath.isEqualToIndexPath( this.selected_index_paths[indexPath.section] ) ) return;

        // Remove all indices after the current section
        for (let index = this.selected_index_paths.length - 1; index >= indexPath.section; index--) {
            let cell = tableView.cellAtIndexPath( this.selected_index_paths[index] );
            if (cell) cell.isSelected = false;
            this.selected_index_paths.splice( index, 1 );
            this.selected_categories.splice( index, 1 );
        }

        // Update the selection at the current section
        this.selected_index_paths[indexPath.section] = indexPath;

        let cell = tableView.cellAtIndexPath( indexPath );
        if (cell) cell.isSelected = true;

        const cat = this.filter_categories[ indexPath.section ][ indexPath.row ];
        if ( cat["SubCategories"] != null ) {
            this.selected_categories[indexPath.section] = cat["ID"] ;
            this.filterSelectedItems();
            this.delegate?.categoryDidChange( this, null );
        }
        else {
            this.delegate?.categoryDidChange( this, cat["ID"] );
        }

        this.tableView.reloadData();
    }

    private categories: any[] = [];
    private fetchCategories(){
        if (this.spinLoaderView) this.spinLoaderView.hidden = false;
        this.categories = [];
        this.category_by_id = {};
        this.root_categories = [];
        this.selected_categories = [];
        this.filter_categories = [];
        this.selected_index_paths = [];
        this.view.hidden = false;

        DLDB.shared.presetCategories( (code, res) => {
            if (this.spinLoaderView) this.spinLoaderView.hidden = true;

            if ( code === 200 ){
                this.mapCategories( res.data );
                this.filterSelectedItems();
                this.tableView.reloadData();

                // Presets can hold products directly, without any category. In that case nothing can ever be
                // selected here, so tell the delegate to load the whole preset product list instead.
                if ( this.categories.length == 0 ) {
                    this.view.hidden = true;
                    this.delegate?.noCategoriesAvailable?.( this );
                }
            }
        } ) ;
    }
    
        
    private category_by_id = {};
    private root_categories: any[] = [];
    private selected_categories: any[] = [];
    private filter_categories: any[] = [];

    private mapCategories( categories: any[] ){
        this.categories = categories;

        for (let c of this.categories) {
            this.category_by_id[ c["ID"] ] = c;
            if ( c["ParentCategoryID"] == null ) this.root_categories.push( c );
        }

        for (let c of this.categories) {
            if ( c["ParentCategoryID"] != null ) {
                let parent = this.category_by_id[ c["ParentCategoryID"] ];
                if ( parent["SubCategories"] == null ) parent["SubCategories"] = [];
                parent["SubCategories"].push( c );
            }
        }
    }
    
    private filterSelectedItems( ){
        this.filter_categories[0] = this.root_categories;
        for (let index = 0; index < this.selected_categories.length; index++) {
            const id = this.selected_categories[index];
            const cat = this.category_by_id[ id ];
            this.filter_categories[index + 1] = cat["SubCategories"];
        }        
    }
     
}